import { render } from "./AllPrograms.vue?vue&type=template&id=4da81d21&scoped=true"
import script from "./AllPrograms.vue?vue&type=script&lang=js"
export * from "./AllPrograms.vue?vue&type=script&lang=js"

import "./AllPrograms.vue?vue&type=style&index=0&id=4da81d21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da81d21"]])

export default __exports__